type QuillRegistry = {
  imports: Record<string, unknown>;
  register: (name: string, module: unknown) => void;
};

type QuillEditor = {
  on: (
    event: "text-change",
    handler: (delta: unknown, oldDelta: unknown, source: string) => void
  ) => void;
  getText: () => string;
  deleteText: (index: number, length: number) => void;
};

export const registerMaxLengthModule = (Quill: QuillRegistry): void => {
  if (Quill.imports["modules/maxlength"]) return;

  class MaxLengthModule {
    constructor(quill: QuillEditor, options: { maxLength: number }) {
      quill.on("text-change", (_delta, _oldDelta, source) => {
        if (source === "api") return;

        const text = quill.getText().trim();
        if (text.length <= options.maxLength) return;

        // Validation is now handled by parent component via errorText prop
        // No longer showing error toast or deleting text
      });
    }
  }

  Quill.register("modules/maxlength", MaxLengthModule);
};
